import React, { Component } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: stretch;
  justify-content: center;
  background-color: #CCC2C2;
  padding: 20px;
  height: 100%;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Logo = styled.img`
  max-width: 100%;
`;

const Spacer = styled.div`
  height: ${props => props.height || 30}px;
`;

const UserName = styled.div`
  font-size: 32px;
  padding: 10px;
  padding-bottom: 30px;
  font-family: 'lcdsolid';
  color: #555555;
`;

const StatusText = styled.div`
  font-size: 16px;
  padding: 10px;
  font-family: 'lcdsolid';
  color: #555555;
`;

const CountdownText = styled.div`
  font-size: 42px;
  padding-bottom: 10px;
  font-family: 'lcdsolid';
  color: #555555;
`;

const FacebookButton = styled.a`
  display: flex;
  align-items: center;
  align-self: center;
  border-radius: 4px;
  background-color: #965A38;
  padding: 5px 15px 15px 15px;
  text-decoration: none;
`;

const ButtonImage = styled.img`
  margin-right: 5px;
`;

const ButtonText = styled.span`
  font-family: 'lcdsolid';
  font-size: 22px;
  color: #D9A441;
  text-align: center;
  padding-top: 7px;
  padding-left: 5px;
`;

export default class Wait extends Component {
  getStatus() {
    switch (this.props.status) {
      case 'connecting':
        return 'Connecting...';
      case 'loading':
        return 'Loading...';
      case 'noQuiz':
        return 'Starts soon...';
      case 'waiting':
        return 'Starts soon...';
      default:
        return '';
    }
  }

  render() {
    return (
      <Container>
        <ContentContainer>
          <Logo src="/images/eyo.png" alt="Eyo Logo" />
          <Spacer />
          <UserName>{this.props.user.name}</UserName>
          <StatusText>{this.getStatus()}</StatusText>
          <CountdownText>{this.props.clock.countdown || ''}</CountdownText>
          <Spacer />
          <FacebookButton href="https://www.facebook.com/eyoquickquiz" target="_blank">
            <ButtonImage src="/images/like.png" alt="Like" />
            <ButtonText>eyo on facebook</ButtonText>
          </FacebookButton>
        </ContentContainer>
      </Container>
    );
  }
}
